import { FORMAT_DATE } from '@/constants/date-formats';
import { formatDate } from 'date-fns';

/**
 * Get the default "from" date, which is one month ago from today.
 * @returns the date one month ago formatted as DD-MM-YYYY
 */
export const getFromDateDefault = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDate(date, FORMAT_DATE);
};

/**
 * Get the default "to" date, which is today.
 * @returns the date today formatted as DD-MM-YYYY
 */
export const getToDateDefault = () => {
  return formatDate(new Date(), FORMAT_DATE);
};
